import { STATUS_COLORS, JOB_COLORS } from '../constants';

export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || STATUS_COLORS.waiting;
};

export const getJobColor = (jobIndex) => {
  return JOB_COLORS[jobIndex % JOB_COLORS.length];
};

export const generateId = () => {
  return Date.now().toString();
};

export const formatJobForDisplay = (job) => {
  return `${job.companyName} - ${job.position} (${job.bdName})`;
};

export const filterJobs = (jobs, { searchTerm, bdName, status }) => {
  return jobs.filter(job => {
    const matchesSearch = !searchTerm || 
      job.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.position.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesBD = !bdName || job.bdName === bdName;
    const matchesStatus = !status || job.status === status;
    
    return matchesSearch && matchesBD && matchesStatus;
  });
};

export const groupInterviewsByJob = (interviews) => {
  return interviews.reduce((acc, interview) => {
    if (!acc[interview.jobId]) {
      acc[interview.jobId] = {};
    }
    acc[interview.jobId][interview.round] = interview;
    return acc;
  }, {});
};

export const getAvailableRounds = (jobInterviews, editingInterview = null) => {
  const filteredInterviews = jobInterviews
    .filter(interview => !editingInterview || interview.id !== editingInterview.id);
  
  // Check if any interview is rejected - if so, no more rounds can be scheduled
  const hasRejectedInterview = filteredInterviews.some(interview => interview.status === 'rejected');
  if (hasRejectedInterview) {
    return [];
  }
  
  const existingRounds = filteredInterviews
    .map(interview => interview.round)
    .sort((a, b) => a - b);
  
  if (existingRounds.length === 0) return [1];
  
  // Find the next available round (no limit on number of rounds)
  let nextRound = 1;
  while (existingRounds.includes(nextRound)) {
    nextRound++;
  }
  
  return [nextRound];
};

// Date validation utilities
export const isValidFutureDateTime = (dateTime) => {
  const selectedDate = new Date(dateTime);
  const now = new Date();
  return selectedDate > now;
};

export const formatDateTimeForInput = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const getMinDateTime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 30); // Minimum 30 minutes from now
  return formatDateTimeForInput(now);
};

export const validateInterviewDateTime = (dateTime) => {
  if (!dateTime) {
    return { isValid: false, error: 'Date and time are required' };
  }
  
  if (!isValidFutureDateTime(dateTime)) {
    return { isValid: false, error: 'Interview cannot be scheduled in the past' };
  }
  
  return { isValid: true, error: null };
};